import { useState } from 'react';

interface DesktopSidePanelProps {
  shop: {
    name: string;
    category: string[];
    description: string;
    location: string;
    reviewCount: number;
    photoCount: number;
    verified: boolean;
  };
}

export default function DesktopSidePanel({ shop }: DesktopSidePanelProps) {
  const [liked, setLiked] = useState(false);

  return (
    <div className="bg-white rounded-2xl p-5 border border-[#E8E2DA]">
      <h1 className="text-[18px] font-bold text-[#121B35] leading-tight">
        {shop.name}
      </h1>

      <div className="flex gap-2 mt-2.5">
        {shop.category?.map((categoryName) => (
          <span
            key={categoryName}
            className="bg-[#F7F2EA] text-[#121B35] text-[11px] px-2.5 py-1 rounded-full font-medium"
          >
            {categoryName}
          </span>
        ))}
      </div>

      <p className="text-[14px] text-[#536079] mt-2.5 leading-[1.7]">
        {shop.description}
      </p>

      <div className="flex flex-wrap items-center gap-2 mt-2.5 text-[12px] text-[#536079]">
        <span>{shop.location}</span>
        <span className="text-[#E8E2DA]">·</span>
        <span>실제 후기 {shop.reviewCount}개</span>
        <span className="text-[#E8E2DA]">·</span>
        <span>후기 사진 {shop.photoCount}장</span>
      </div>

      {shop.verified && (
        <div className="mt-2.5 inline-flex items-center gap-1.5 bg-[#121B35] text-white text-[11px] px-3 py-1.5 rounded-full">
          <span className="w-1.5 h-1.5 rounded-full bg-[#B9965B]" />
          다이렉트웨딩 후기 기반 검증 업체
        </div>
      )}

      <div className="mt-5 space-y-2">
        <button className="w-full bg-[#121B35] text-white font-semibold rounded-xl py-3 text-[13px] whitespace-nowrap active:opacity-90 transition-opacity">
          상담 문의하기
        </button>
      </div>

      <button
        onClick={() => setLiked(!liked)}
        className={`w-full mt-2 flex items-center justify-center gap-2 rounded-xl py-2.5 text-[12px] font-medium border transition-colors ${
          liked
            ? 'border-red-300 bg-red-50 text-red-400'
            : 'border-[#E8E2DA] text-[#121B35]'
        }`}
        aria-label={liked ? '찜 해제' : '찜하기'}
      >
        <i className={liked ? 'ri-heart-fill text-red-400' : 'ri-heart-line'} />
        {liked ? '찜 목록에 추가됨' : '찜하기'}
      </button>
    </div>
  );
}